import _ from "lodash";

export default (form, setFieldValue) => id => {
  setFieldValue("media", _.filter(form.media, item => item._id !== id));
};
